import React from 'react'

type GradeLetter = 'A' | 'B' | 'C' | 'D' | 'E'
type GradeSize = 'sm' | 'md' | 'lg'

interface GradeDisplayProps {
  grade: GradeLetter
  size?: GradeSize
  showLabel?: boolean
  className?: string
}

export const GradeDisplay: React.FC<GradeDisplayProps> = ({
  grade,
  size = 'md',
  showLabel = false,
  className = '',
}) => {
  const getGradeColor = (grade: GradeLetter): string => {
    const colorMap: Record<GradeLetter, string> = {
      A: 'bg-green-100 text-green-800',
      B: 'bg-blue-100 text-blue-800',
      C: 'bg-yellow-100 text-yellow-800',
      D: 'bg-orange-100 text-orange-800',
      E: 'bg-red-100 text-red-800',
    }

    return colorMap[grade]
  }

  const getSizeClasses = (size: GradeSize): string => {
    const sizeMap: Record<GradeSize, string> = {
      sm: 'text-2xl w-12 h-12',
      md: 'text-4xl w-20 h-20',
      lg: 'text-6xl w-32 h-32',
    }

    return sizeMap[size]
  }

  return (
    <div className={`grade-display flex flex-col items-center ${className}`}>
      {showLabel && <span className="text-sm font-semibold text-gray-600 mb-2">Grade</span>}
      <div
        className={`flex items-center justify-center font-bold rounded-full ${getGradeColor(grade)} ${getSizeClasses(size)}`}
      >
        {grade}
      </div>
    </div>
  )
}
